import React, { useEffect, useState } from 'react';
import { ProductModelItem, RelatedProductModelItem } from '../../Related.types';
import { TechnicalDetailsContainer } from './TechnicalDetailsContainer';
import { RelatedList } from '../common/RelatedList';
import dataLayer from '@helpers/dataLayer';
import './RelatedProductModelContainer.scss';

interface RelatedProductModelContainerProps {
  content: ProductModelItem[];
  productLine: RelatedProductModelItem;
  I18n: Record<string, string>;
  styleType: string;
  hideProductModels: boolean;
}

export const RelatedProductModelContainer = ({
  content,
  I18n,
  styleType,
  productLine,
  hideProductModels,
}: RelatedProductModelContainerProps) => {
  const [selectedItem, setSelectedItem] = useState<ProductModelItem>(null);
  const isTechnicalDetailsOpen = !!selectedItem;

  const closeTechnicalDetails = () => {
    setSelectedItem(null);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const productModel = searchParams.get('model');

    if (productModel) {
      const product = content.find((item) => item.ProductModelId === productModel);
      setSelectedItem(product);
    }
  }, []);

  useEffect(() => {
    if (selectedItem) {
      dataLayer.push('view_item', {
        ecommerce: {
          items: [
            {
              item_name: selectedItem?.ProductModelDisplayName,
              product_line: productLine ? productLine.ProductTitle : undefined,
            },
          ],
        },
      });
    }
  }, [selectedItem]);

  // TODO: move to service
  const productModelMapper = (item: ProductModelItem) => {
    return {
      Title: item.ProductModelDisplayName,
      ImageUrl: item.Images[0]?.Thumbnail,
      ImageAlt: item.ProductModelDisplayName,
      Meta: item,
    };
  };
  return (
    <>
      {!hideProductModels && (
        <RelatedList
          styleType={styleType}
          onRelatedItemClick={(item) => {
            setSelectedItem(item.Meta);
          }}
          items={content.map(productModelMapper)}
          i18n={I18n}
        />
      )}
      {isTechnicalDetailsOpen && (
        <TechnicalDetailsContainer
          defaultSelectedItem={selectedItem}
          productLine={productLine}
          products={content}
          i18n={I18n}
          handleClose={closeTechnicalDetails}
        />
      )}
    </>
  );
};
